import type { Skill } from '../../../types/skill'
import styles from './SkillTag.module.css'

interface SkillTagProps {
  skill: Skill
}

export function SkillTag({ skill }: SkillTagProps) {
  return (
    /*
     * Lien cliquable vers la documentation officielle.
     * Le data-category permet au CSS de coloriser selon la catégorie
     * sans JavaScript supplémentaire.
     */
    <a
      href={skill.url}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.tag}
      data-category={skill.category}
      aria-label={`${skill.label} — voir la documentation officielle`}
    >
      {skill.label}
    </a>
  )
}